<template>
  <div class="page-component-wrapper">
    <layout :isEmpty="false" :messageEmpty="L10n('select-a-part')" v-loading="isLoading">
      <template v-slot:header>
        <h1 class="page-title">{{pageTitle}}</h1>
      </template>
      <template v-slot:tools>
        <top-panel
          v-model="rfqID"
        ></top-panel>
      </template>
      <template v-slot:content>
        <layout-scroll-content>
          <div style="display: flex; flex-direction: column; height: 100%;">
            <editor
              v-show="isVisible"
              :config="{ id: moduleName, permission: 'isAllowToViewRFQs' }"
              :moduleName="moduleName"
            ></editor>
          </div>
        </layout-scroll-content>
      </template>
    </layout>
  </div>
</template>

<script>
import StoreModule from './StoreModule.js'
export default {
  name: 'RFQPurchaseIndex',
  components: {
    'layout': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/PagePanel'),
    'layout-scroll-content': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/EditorPage/ScrollContent.vue'),
    'top-panel': () => import(/* webpackChunkName: 'RFQPurchase' */ './TopPanel.vue'),
    'editor': () => import(/* webpackChunkName: 'RFQPurchase' */ './Editor/Index.vue')
  },
  created () {
    const store = this.$store
    const moduleName = this.moduleName
    if (store && !store.state[moduleName]) {
      store.registerModule(moduleName, StoreModule)
    }
  },
  data () {
    return {
      moduleName: 'rfq-purchase'
    }
  },
  computed: {
    rfqID: {
      get () {
        return this.$store.state[this.moduleName].dataRFQ.id
      },
      set (value) {
        if (value) {
          let query = Object.assign({}, this.$route.query, { [this.moduleName]: `edit[${value}]` })
          this.$router.replace({ ...this.$router.currentRoute, query })
        } else {
          let query = Object.assign({}, this.$route.query)
          delete query[this.moduleName]
          this.$router.replace({ query: query })
        }
      }
    },
    isVisible () {
      return this.$store.getters[`${this.moduleName}/isVisible`]
    },
    isLoading () {
      return this.$store.state[this.moduleName].isLoading
    },
    pageTitle () {
      return this.L10n(this.$route.meta.label)
    }
  }
}
</script>
